import { render, staticRenderFns } from "./form-input.vue?vue&type=template&id=04fc6f05"
import script from "./form-input.vue?vue&type=script&lang=ts"
export * from "./form-input.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports